import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../default-cloud-graph-document-entity-ati';
import { TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { AdobeSignIcon } from './icon';
import { AdobeSignSearchResultIcon } from './search-result-icon';

export const adobeSignConfig: ThirdPartyConfig = {
	displayName: 'Adobe Sign',
	id: 'adobe-sign',
	resourceType: 'adobe-sign-connector',
	icon: get3PLogo(AdobeSignIcon, 'Adobe Sign', 'medium'),
	searchResultIcon: get3PLogo(AdobeSignSearchResultIcon, 'Adobe Sign', 'large'),
	integrationAri: 'ari:cloud:platform::integration/adobe',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Document,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	requiresOauth: true,
	isEnabled: () => true,
};
